import { render, staticRenderFns } from "./PopoutCarousel.vue?vue&type=template&id=075fdeb4&scoped=true"
import script from "./PopoutCarousel.vue?vue&type=script&lang=js"
export * from "./PopoutCarousel.vue?vue&type=script&lang=js"
import style0 from "./PopoutCarousel.vue?vue&type=style&index=0&id=075fdeb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "075fdeb4",
  null
  
)

export default component.exports